import { useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { useSelector } from 'react-redux';

import getAppUser from '../store/selectors/getAppUser';
import getServiceProvider from '../store/selectors/getServiceProvider';

const useMixpanelProfileConfig = () => {
  const appUser = useSelector(getAppUser);
  const serviceProvider = useSelector(getServiceProvider);
  useEffect(
    () => {
      if (appUser && serviceProvider) {
        mixpanel.identify(appUser.userId);
        mixpanel.people.set({
          '$name': appUser.displayName,
          '$email': appUser.userId,
          '$officer_level': appUser.officerLevel,
          '$role': appUser.role,
          '$service_provider_id': serviceProvider.serviceProviderId,
          '$service_provider_name': serviceProvider.fullName
        });
      }
    },
    [appUser, serviceProvider]
  );
};

export default useMixpanelProfileConfig;